import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionsMenu = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.menu"
    })
  }, props, {
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      "data-test-id": "open-actions-menu",
      children: children
    })
  }));
};
export default ActionsMenu;